<template>
  <a-layout-content>
    <s-banner></s-banner>
    <div style="min-height: 750px;">
    <div style="font-size:18px;font-weight:bold;color:black;padding-bottom:10px;border-bottom:1px solid rgb(220,220,220);">账号绑定</div>
    
    
    <div class="bind" v-if="bind == false">
      <div style="width:120px;height:120px;display:inline-block;">
        <img :src="require('@/assets/img/wechat.png')"/>
      </div>
      <div style="display:inline-block;padding-left:20px;">
        <div><span style="color:rgb(102,102,102)">关联微信号：</span>抱歉你暂未绑定</div>
        <a href="https://open.weixin.qq.com/connect/qrconnect?appid=wxe092ca36314eab6e&redirect_uri=http://zhizhan360.showguide.cn/account/related&response_type=code&scope=snsapi_login&state=STATE#wechat_redirect">
          <span style="display:inline-block;height:18px;line-height:18px;">
            <img src="~@/assets/img/bind-icon.png" style="display:inline-block;">
            <span style="color:rgb(0,139,211);display:inline-block;margin-left:3px;">绑定账号</span>
          </span>
        </a>
      </div>
    </div>
    <div class="unBind" v-if="bind == true" style="margin-top:30px;">
      <div style="width:120px;height:120px;display:inline-block;">
        <img :src="headUrl || require('@/assets/img/wechat.png')" style="width:100px;height:100px;border-radius:50%; border:1px solid rgb(0,139,211);"/>
      </div>
         <div style="display:inline-block;">
           <div><span style="color:rgb(102,102,102)">关联微信号：</span>{{nickname}}</div>
           <span style="display:inline-block;height:18px;line-height:18px;">
              <img src="~@/assets/img/bind-icon.png" style="display:inline-block;">
              <span style="color:rgb(0,139,211);display:inline-block;margin-left:3px;" @click="showModal">解除绑定</span>
           </span>
        </div> 
    </div>
    <!-- <a-button type="primary" @click="showModal" v-if="bind == true">解除绑定  </a-button> -->
    <a-modal
      title="操作提示"
      v-model="visible"
      :mask="false"
      :centered="true"
      :width="370"
      :footer="null"
    >
      <p style="color:rgb(255,107,107)">请确认是否解除当前微信与{{nickname}}的绑定关系</p>
      <div style="color:rgb(0,139,211);margin-top:70px;text-align:center;" @click="unbindAccount">
        确认解绑
       <img src="~@/assets/img/left-arrow.png" style="display:inline-block;">
        </div>
    </a-modal>
    </div>
  </a-layout-content>
  
</template>
<script>
import Banner from "./banner";
export default {
  components: { "s-banner": Banner },
  data() {
    return {
      bind:false,
      headUrl : '',
      nickname: '',
      visible: false,
    };
  },
  created(){
    this.getcode();
  },
  methods: {
    showModal(){
      this.visible = true
    },
    getcode(){
      const code = this.$route.query.code; 
       if (typeof code != 'undefined') {
        this.$http
          .post("/zzOpenid", {
            token: this.$cookies.get("access-token") || "",
            code:code,
          })
          .then(res => {
            console.log(res)
            if(res.error == 0){
              this.isBindAccount();
            }
          })
       }else{
         this.isBindAccount();
       }
    },
    isBindAccount(){
      this.$http
        .post("/isBindAccount", {
          token: this.$cookies.get("access-token") || ""
        })
        .then(res => {
          console.log(res)
          if(res.error == 0){
            this.bind = true
            this.headUrl = res.avatar
            this.nickname = res.nickname
          }else{
            this.bind = false
            this.headUrl = ''
          }
        })
    },
    unbindAccount(){
      this.$http
        .post("/unbindAccount", {
          token: this.$cookies.get("access-token") || ""
        })
        .then(res => {
          if(res.error == 0){
            this.isBindAccount();
          }
        })
      this.visible = false
      
    }
  },
};
</script>
<style lang="scss" scoped>
@import "~@/components/layout/style/mixin.scss";
  .bind{
    margin-top: 30px;
  }

</style>

